import { createDuck, createEntityCollection } from '@/utils'
import { getAddOnData } from '@/services/api/classify'
import { addCart } from '@/services/api/common'
import { formatData } from '@/utils/addon'
import { duck as commonDuck } from './common'
import { Toast } from 'antd-mobile-v2'
import { SHOP_ID } from '@/utils/const'

export const duck = createDuck({
  name: 'addonDuck',
  initialState: {
    status: 0,
    list: null,
    curItem: {
      defaultSubItem: {},
      count: 1,
      subItems: [],
      status: 0,
    },
    entities: null,
    postage: null,
    col: null,
    visible: false,
  },
  actions: {
    initPageData(activityIds) {
      return async dispatch => {
        dispatch(duck.fetchData())
        dispatch(commonDuck.fetchPostage(activityIds))
      }
    },

    fetchData() {
      return async dispatch => {
        const { data, error } = await getAddOnData(SHOP_ID)
        if (!error) {
          // formatData(data.list)
          const col = createEntityCollection(formatData(data.list), x => x.itemId)
          dispatch(
            duck.change({
              list: col.list,
              entities: col.entities,
              // col: col,
              status: 1,
            }),
          )
        } else {
          Toast.info(error.message || '获取数据失败')
          dispatch(
            duck.change({
              status: 2,
            }),
          )
        }
      }
    },

    toggelModal(val) {
      return dispatch => {
        dispatch(
          duck.change({
            visible: val,
          }),
        )
      }
    },
    changeCurItem(data) {
      return dispatch => {
        dispatch(
          duck.change({
            curItem: {
              ...data,
              count: 1,
            },
          }),
        )
      }
    },
    changeSku(newData) {
      return (dispatch, getState) => {
        const { addonDuck } = getState()
        dispatch(
          duck.change({
            curItem: {
              ...addonDuck.curItem,
              defaultSubItem: { ...newData },
              count: 1,
            },
          }),
        )
      }
    },

    /**
     * 修改数量
     * @param {number} val
     * @returns
     */
    changeNum(val) {
      return (dispatch, getState) => {
        const { addonDuck } = getState()
        const { curItem = {} } = addonDuck

        dispatch(
          duck.change({
            curItem: {
              ...curItem,
              count: val,
            },
          }),
        )
      }
    },

    //添加到购物车
    addCart(data, activityIds) {
      return async dispatch => {
        //判断是否为预售商品
        const { error } = await addCart({
          count: data.count,
          subItemId: data.subItemId,
          choice: data.status === 100 ? false : true,
        })
        if (!error) {
          Toast.info('添加商品成功')
          //更新邮费信息
          dispatch(commonDuck.fetchPostage(activityIds))
          //更新购物车数量信息
          dispatch(commonDuck.fetCartSummaryInfo())
        } else {
          Toast.info((error && error.message) || '加入购物车失败')
        }
        dispatch(
          duck.change({
            visible: false,
          }),
        )
      }
    },
  },
})
